import { render, staticRenderFns } from "./atencionPaciente.vue?vue&type=template&id=15127c4d&scoped=true&"
import script from "./atencionPaciente.vue?vue&type=script&lang=js&"
export * from "./atencionPaciente.vue?vue&type=script&lang=js&"
import style0 from "./atencionPaciente.vue?vue&type=style&index=0&id=15127c4d&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15127c4d",
  null
  
)

export default component.exports